/* Lotje bestelpagina - gsm: mandje schuift open na toevoegen, balk onderaan toont aantal en totaal */
(function () {
  var mq = window.matchMedia('(max-width: 899px)');
  function init(root) {
    if (!root || root.dataset.lbGsm) return;
    var aside = root.querySelector('.lb__aside');
    var bar = root.querySelector('[data-lb-bar]');
    var back = root.querySelector('[data-lb-backdrop]');
    var countEl = root.querySelector('[data-lb-count]');
    var totalEl = root.querySelector('[data-lb-total]');
    if (!aside || !bar || !back || !countEl || !totalEl) return;
    root.dataset.lbGsm = '1';
    var barCount = bar.querySelector('[data-lb-bar-count]');
    var barTotal = bar.querySelector('[data-lb-bar-total]');
    var barLabel = bar.querySelector('[data-lb-bar-label]');
    var closeBtn = aside.querySelector('[data-lb-aside-close]');
    var lastFocus = null;
    var prev = null;

    function isOpen() { return aside.classList.contains('is-open'); }
    function open() {
      if (!mq.matches || isOpen()) return;
      lastFocus = document.activeElement;
      aside.classList.add('is-open');
      back.classList.add('is-open');
      bar.setAttribute('aria-expanded', 'true');
      document.documentElement.style.overflow = 'hidden';
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    }
    function close() {
      if (!isOpen()) return;
      aside.classList.remove('is-open');
      back.classList.remove('is-open');
      bar.setAttribute('aria-expanded', 'false');
      document.documentElement.style.overflow = '';
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    }
    function bump() {
      bar.classList.remove('is-bump');
      void bar.offsetWidth;
      bar.classList.add('is-bump');
    }
    function sync() {
      var n = parseInt(countEl.textContent, 10) || 0;
      barCount.textContent = n;
      barCount.hidden = !n;
      barTotal.textContent = totalEl.textContent;
      barLabel.textContent = n ? bar.dataset.full : bar.dataset.empty;
      if (prev !== null && n > prev) { bump(); open(); }
      prev = n;
    }

    bar.addEventListener('click', open);
    back.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);
    aside.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
    var onMq = function () { if (!mq.matches) close(); };
    if (mq.addEventListener) mq.addEventListener('change', onMq); else if (mq.addListener) mq.addListener(onMq);
    var mo = new MutationObserver(sync);
    mo.observe(countEl, { childList: true, characterData: true, subtree: true });
    mo.observe(totalEl, { childList: true, characterData: true, subtree: true });
  }
  function run() { document.querySelectorAll('[data-lb]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  document.addEventListener('shopify:section:load', function (e) { var r = e.target.querySelector('[data-lb]'); if (r) init(r); });
})();
